const tmpwindow = window as any;

const configs = {
  VUE_APP_BASE_API: tmpwindow.configFile.VUE_APP_BASE_API,
  VUE_APP_BASE_YARDVIEW: tmpwindow.configFile.VUE_APP_BASE_YARDVIEW,
  VUE_APP_TILE_IP:tmpwindow.configFile.VUE_APP_TILE_IP,
  VUE_APP_TILE_ROUTE:tmpwindow.configFile.VUE_APP_TILE_ROUTE,
  VUE_APP_IS_ONLINE_MAP:tmpwindow.configFile.VUE_APP_IS_ONLINE_MAP
};
export default configs;
